<template>
  <div class="wrapper">
    <div>
      <el-card>
        <div class="data_list">
          <ul>
            <li>
              <div>{{dataForm.commentCount}}</div>
              <span> {{$t("other.wealth.commentTotalCount")}}</span>
            </li>
            <li>
              <div>{{this.dataForm.auditPassCount}}</div>
              <span>{{$t("other.wealth.auditPassCount")}}</span>
            </li>
            <li>
              <div>{{this.dataForm.auditNotPassCount}}</div>
              <span>{{$t("other.wealth.auditNotPassCount")}}</span>
            </li>
            <li>
              <div>{{this.dataForm.notAuditCount}}</div>
              <span>{{$t("other.wealth.notAuditCount")}}</span>
            </li>
          </ul>
        </div>
      </el-card>
    </div>
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @btnclick="bthClick"  @checkbox="checkbox" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE ref="auditUpdate"  @submit="auditClick" :updateData="auditData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '@/components/page/table.vue'
    import FORM from '@/components/page/form.vue'
    import UPDATE from '@/components/page/update.vue'
    //接口地址url的统一管理
    import Qs from 'qs'
    import Url from "@/views/other/util/url"
    import download from '@/utils/download'
    let type = {"0": window.$t("other.wealth.shortEssay"),"1": window.$t("other.wealth.longEssay")};
    let topicList = {};
    let check=[];
    let commentStatus={"0":window.$t("other.wealth.notAudit"),"1":window.$t("other.wealth.pass"),"2":window.$t("other.wealth.noPass")};
    let commentStatus2={"1":window.$t("other.wealth.pass"),"2":window.$t("other.wealth.noPass")};
    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },

        created(){
            this.loadDetail();
        },
        mounted(){
        },
        methods: {
          checkbox(rows){
              this.check = rows;
              console.log(rows);
          },
            auditClick(row){
                this.$axios.get(`${Url.wealthComment.update}/${row.id}`+'?status='+row.commentStatus).then(res => {
                    if (res.code == 0){
                        this.$refs.auditUpdate.close();
                        this.$refs.childTable.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            loadDetail(){
                this.$axios.get(`${Url.wealthComment.statistical}/${this.$route.query.articleId}`).then(res => {
                    if (res.code == 0){
                        this.dataForm = {
                            ...this.dataForm,
                            ...res.result
                        }
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
          /*表格按钮点击事件*/
          bthClick (clickName, row) {
            if (clickName == "update"){
              this.$refs.childUpdate.open(row);
            }else if (clickName == "updateStatus"){
                if(row.commentStatus == 0){
                  this.$refs.auditUpdate.open(row);
                }else{
                  let status = row.commentStatus == 1 ? 2:1;
                  let conf = row.commentStatus == 1 ? window.$t("other.wealth.noPass"):window.$t("other.wealth.pass");
                    this.$confirm(window.$t("common.ok")+conf, window.$t("common.tip"), {
                      distinguishCancelAndClose: true,
                      confirmButtonText: window.$t("common.ok"),
                      cancelButtonText: window.$t("common.cancle")
                  }).then(() => {
                      this.$axios.get(`${Url.wealthComment.update}/${row.id}`+'?status='+status).then(res => {
                          if (res.code == 0){
                              this.$refs.childTable.defaultGetData(this.queryData);
                              this.$message.success("suc");
                          }else{
                              this.$message.error(res.message);
                          }
                      });
                  })
                }
            } else if (clickName == "delete"){
                this.$axios.get(`${Url.wealthComment.deleteBatchId}/${row.id}`).then(res => {
                    if (res.code == 0){
                        this.$refs.childTable.defaultGetData(this.queryData);
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                });
        } else if(clickName == "copy"){
                row.id=0.1;
                this.$refs.childUpdate.open(row);
            }
          },
            downloadTopicComments(data){
                download.exportExcel(Url.wealthComment.downloadTopicComments, data, "");
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(window.$t("common.search") == clickName || "查询" == clickName){
                    this.queryData = data;
                    this.$refs.childTable.defaultQueryData(data);
                }else if(window.$t("other.wealth.addComment")==clickName){
                  this.$refs.childUpdate.open();
                }
            },

            /*新增或跟提交数据触发事件*/
            submit(model){
                if(model.id == 0.1){
                    model.id = null;
                    model.articleId = this.$route.query.articleId;
                }
                //根据是否包含id更新还是添加
                this.dataChanage(Url.wealthComment.addOrUpdate,model,res => {
                    if (res.code == 0){
                        this.$refs.childUpdate.close();
                        this.$message.success("suc");
                    }else{
                        this.$message.error(res.message);
                    }
                })
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, option || {},{ headers: { 'Content-Type': 'application/json' } }).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            }
        },
        data () {
            return {
                dataForm: {
                    commentCount:0,
                    auditPassCount:0,
                    auditNotPassCount:0,
                    notAuditCount:0
                },
                deleteIds:"",
                queryData:{},
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t("other.wealth.audit"), field: 'commentStatus',type:2,optionList:commentStatus,isNumber:true,required:true},
                        {click:window.$t("common.search")},
                        {click: window.$t("other.wealth.addComment")},
                    ]
                },
                auditData:{
                    hasLable: true,
                    cols:[
                        { title: '主键', field: 'id',hidden:true},
                        { title: window.$t("other.wealth.audit"), field: 'commentStatus',type:3,optionList:commentStatus2,isNumber:true,data:1},
                    ]
                },
                /*新增*/
                updateData: {
                    hasLable: true,
                    cols:[
                        { title: '主键', field: 'id',hidden:true},
                        { title: '文章Id', field: 'articleId',hidden:true,data:this.$route.query.articleId},
                        { title:  window.$t("other.wealth.type"), field: 'type',type:3,optionList:type,isNumber:true,data:this.$route.query.type,disabled:true},
                        { title: window.$t("other.wealth.title"), field: 'title',data:this.$route.query.title,disabled:true},
                        { title: window.$t("other.wealth.content"), field: 'content',type:6,data:this.$route.query.content,disabled:true},
                        { title:  window.$t("other.wealth.phone"), field: 'phone',required:true,required:true},
                        { title: window.$t("other.wealth.nickName"), field: 'nickName',required:true,required:true},
                        { title: window.$t("other.wealth.commentTime"), field: 'createTime',type:5,format:"yyyy-MM-dd HH:mm:ss",required:true},
                        { title: window.$t("other.wealth.commentStatus"), field: 'commentStatus',type:2,optionList:commentStatus,data:1,required:true,isNumber:true},
                        { title: window.$t("other.wealth.remark"), field: 'remark',textType:"textarea",required:true}
                      ]
                },
                /*table生成*/
                pageData: {
                    isShow: false,
                    queryUrl: Url.wealthComment.query+"?articleId="+this.$route.query.articleId,
                    selection: false,
                    sequence: false,
                  method:"get",
                    cols: [
                        { title: window.$t("other.wealth.title"), field: 'title'},
                        { title: window.$t("other.wealth.content"), field: 'content'},
                        { title:  window.$t("other.wealth.type"), type:2,field: 'type',render:(data)=>{
                                return type[data];
                         }},
                        { title:  window.$t("other.wealth.nickName"), field: 'nickName'},
                        { title: window.$t("other.wealth.commentTime"), field: 'createTime'},
                        { title: window.$t("other.wealth.remark"), field: 'remark'},
                        { title:  window.$t("other.wealth.commentStatus"), field: 'commentStatus',render:(data)=>{
                                return commentStatus[data];
                            }},
                        {title: window.$t("common.handle"),width:'350px',btnClick:[
                                {
                                    name:window.$t("other.wealth.copy"),click:"copy",type:"primary",icon:"el-icon-edit"
                                },
                            {
                             name:(data,full)=>{
                                  if(full.commentStatus == 0){
                                      return window.$t("other.wealth.audit")
                                  }else if(full.commentStatus == 1){
                                      return window.$t("other.wealth.noPass")
                                  }else{
                                      return window.$t("other.wealth.pass")
                                  }
                               },click:"updateStatus",type:"primary",icon:"el-icon-edit",confirm:false
                           }, {
                                    name: window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit"
                                },
                                {
                                    name: window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete"
                                },
                            ]
                        },
                    ]
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
  .data_list {
    ul {
      display: flex;
      justify-content: space-between;
      align-items: center;
      li {
        text-align: center;
        div {
          font-size: 26px;
          color: #333;
        }
        span {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
  ul,
  li {
    list-style: none;
  }
</style>
